import LessonCompleteView from "@/components/pages/CompletedLesson/features/LessonCompleteView";
import { TUTRED_CLIENT_HOSTNAME } from "@/constants";
import useFirebaseContext from "@/hooks/useFirebaseAuth";
import { UserRole } from "@/types";

const CancelledLesson = () => {
  const { userRole } = useFirebaseContext();

  const actions = {
    [UserRole.Student]: {
      title: "The lesson has been cancelled",
      description:
        "You'll receive a refund for the lesson within 5-10 business days.",
      buttonText: "Back to Tutred",
      buttonLink: `/student/home`,
    },
    [UserRole.Tutor]: {
      title: "The lesson has been cancelled",
      description: "Hopefully the next lesson works out!",
      buttonText: "Back to Tutred",
      buttonLink: `/tutor/home`,
    },
  };

  const primaryHref = `${TUTRED_CLIENT_HOSTNAME}${actions[userRole].buttonLink}`;

  return (
    <LessonCompleteView
      title={actions[userRole].title}
      description={actions[userRole].description}
      primaryLabel={actions[userRole].buttonText}
      primaryHref={primaryHref}
    />
  );
};

export default CancelledLesson;
